import { call } from "@saas/api-client";
import { AppShell, RequireRole, useAsync, useSession } from "@saas/ui";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Link, Outlet, RouterProvider } from "react-router";
import { api } from "./api";
import { BookingsPage } from "./BookingsPage";
import { IdentityPage } from "./IdentityPage";
import { MembersPage } from "./MembersPage";
import { RoomsPage } from "./RoomsPage";
import { SettingsPage } from "./SettingsPage";

function Layout() {
  const session = useSession();
  const tenant = useAsync(() => call(api.GET("/api/my-tenant")), []);
  useEffect(() => {
    // First sign-in accepts the invitation; later ones update "last sign-in".
    void api.POST("/api/me/sign-ins");
  }, []);
  return (
    <AppShell
      surfaceLabel={tenant.data ? `Tenant admin · ${tenant.data.displayName}` : "Tenant admin"}
      nav={[
        { to: "/", label: "Members" },
        { to: "/rooms", label: "Rooms" },
        { to: "/bookings", label: "All bookings" },
        { to: "/settings", label: "Settings" },
        { to: "/identity", label: "Identity provider" },
      ]}
      userLabel={session.email ?? "TenantAdmin"}
      logoutUrl={session.logoutUrl}
    >
      <Outlet />
    </AppShell>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { index: true, element: <MembersPage /> },
        { path: "rooms", element: <RoomsPage /> },
        { path: "bookings", element: <BookingsPage /> },
        { path: "settings", element: <SettingsPage /> },
        { path: "identity", element: <IdentityPage /> },
        { path: "*", element: <p>Page not found. <Link to="/">Back to members</Link></p> },
      ],
    },
  ],
  { basename: "/tenant" },
);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element.");

createRoot(root).render(
  <StrictMode>
    <RequireRole surface="tenant" title="Tenant administration">
      <RouterProvider router={router} />
    </RequireRole>
  </StrictMode>,
);
